import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { useSarlaftFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { SarlaftFiltersProps } from './props';

export const SarlaftFilters = ({ onFilter, loading }: SarlaftFiltersProps) => {
    const { formik, status } = useSarlaftFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="ID caso"
                    name="caseId"
                    size="small"
                    touched={formik.touched.caseId}
                    errors={formik.errors.caseId}
                    value={formik.values.caseId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Cuenta"
                    name="account"
                    size="small"
                    touched={formik.touched.account}
                    errors={formik.errors.account}
                    value={formik.values.account}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={status}
                    label="Estado del caso"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de formulario"
                    name="numberForm"
                    size="small"
                    touched={formik.touched.numberForm}
                    errors={formik.errors.numberForm}
                    value={formik.values.numberForm}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipificación 1"
                    name="typification1"
                    size="small"
                    touched={formik.touched.typification1}
                    errors={formik.errors.typification1}
                    value={formik.values.typification1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipificación 2"
                    name="typification2"
                    size="small"
                    touched={formik.touched.typification2}
                    errors={formik.errors.typification2}
                    value={formik.values.typification2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('created_at', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    maxDate={dayjs()}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('created_at', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
